module.exports = __webpack_public_path__ + "static/bg.cead1d11.png";